import React, { useEffect, useState, useRef } from "react";
import { Tabs, Dropdown, Pagination ,Message, Dialog} from "@jdcfe/legao";
import { UploadOutlined, PlusOutlined, VerticalAlignBottomOutlined } from '@ant-design/icons';
import { Popover, Modal, Form,
  Table,
  Input,
  Radio,
  Select,
  Checkbox,
  Upload,
  Button,
  Switch } from 'antd';
import { SketchPicker, CompactPicker } from 'react-color'
import { observer } from "mobx-react-lite";
import useStore from "stores";
import useStores from 'stores';
import PermissionDetaidefaultValuel from "./../PermissionDetail";
import { useHistory,Link } from "react-router-dom";
import {
  queryAuthPackList,
  applyAccessChoose,
  appPackqueryAuthPackList,
  switchAuthPack,
  // queryComponentCount,
  queryComponentList,
  subComponent,
  queryComponentConfig,
  querySubmitComponentConfig,
  queryComponentUpload,
  queryRejectReason,
  cancelComponent,
} from "utils/api";
import qs from "qs";
import NoPermission from "./../NoPermission";
import "./style.scss";

const tableColumn = [
  {
    title: "消息名称",
    dataIndex: "name",
    key: "1",
    width: 150,
  },
  {
    title: "消息类型",
    dataIndex: "type",
    key: "2",
    width: 80,
  },
  {
    title: "消息分组",
    dataIndex: "group",
    key: "3",
    width: 120,
  },
  {
    title: "消息体",
    dataIndex: "body",
    key: "4",
    width: 180,
    className: 'w1-cell'
  },
  {
    title: "备注说明",
    dataIndex: "explain",
    key: "5",
    width: 180,
  },
  {
    title: "订阅状态",
    dataIndex: "status",
    key: "6",
    width: 80,
  },
  {
    title: "操作",
    dataIndex: "oper",
    key: "7",
    width: 80,
  },
];
const tableColumn1 = [
  {
    title: "权限包名称",
    dataIndex: "name",
    key: "1",
    width: 250,
  },
  {
    title: "场景描述",
    dataIndex: "type",
    key: "2",
    width: 300,
  },
  {
    title: "权限项目",
    dataIndex: "group",
    key: "3",
    width: 200,
  },

  {
    title: "状态",
    dataIndex: "status",
    key: "6",
    width: 150,
  },
  {
    title: "操作",
    dataIndex: "oper",
    key: "7",
    width: 200,
  },
];

const SubscribeContent = observer(() => {
  const [empty, setEmpty] = useState(null);
  const [defaultCurrent, setDefaultCurrent] = useState(1);
  const [pageCurrent, setPageCurrent] = useState(1);
  const [status, setStatus] = useState(-1);
  const [groupName, setGroupName] = useState("请选择");
  const [groupStyle, setGroupStyle] = useState(false);
  const [stateStyle, setStateStyle] = useState(false);
  const { subscriptionStore, overviewStore } = useStore();
  const [tabActive, settabActive] = useState(0);
  const [tabMsg, settabtabMsg] = useState("暂无已开通权限包");
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  const [tableData1, settableData1] = useState([]);
  const [tableData2, settableData2] = useState([]);
  const [componentRes1, setcomponentRes1] = useState([]); // 已订阅组件数据
  const [componentRes0, setcomponentRes0] = useState([]); // 未订阅组件数据
  const [componentData1, setcomponentData1] = useState([]); // 已订阅组件数据
  const [componentData0, setcomponentData0] = useState([]); // 未订阅组件数据
  const [isConfogVisible, setIsConfogVisible] = useState(false); // 配资弹窗显示
  const [isCompoentId, setIsCompoentId] = useState(''); // compoentId
  const [configDesc, setConfigDesc] = useState([]); // 配资弹窗数据配置文章id
  const [configData, setConfigData] = useState([]); // 配资弹窗数据
  const [isDisabled, setIsDisabled] = useState(false); // 是否是查看配资弹窗
  const [modalState, setModalState] = useState(''); // 有add、edit、check
  const [configColor, setConfigColor] = useState([]); // 颜色选择器颜色
   const [isShowImgUrlLink,setIsShowImgUrlLink]= useState({});
   const [linkUrlObj,setLinkUrlObj] = useState({})
  const history = useHistory();
  const formEl = useRef(null);

  useEffect(() => {
    subscriptionStore.getHistory(history);
    if (empty == null) {
      queryAuthPackList({
        appKey: query.appKey,
        openStateType: null,
      }).then((res) => {
        setEmpty(!res.data.result);
      });
    }
    if (!empty) {
      queryData();
      if(query.appKey){
        overviewStore.queryAppBaseInfo(query.appKey);
      }
    }
  }, [empty]);

  /*eslint-disable*/
  const handleChange = (index) => {
    setDefaultCurrent(1);
    setPageCurrent(1);
  };
  const queryData = () => {
    
    subscriptionStore.queryClientMsgInfoList({
      appKey: query.appKey,
      pageIndex: 1,
    });
    // 请求权限包订阅数据
    queryClientLimitInfoList({
      appKey: query.appKey,
      openStateType: 1,
    });
    queryClientLimitInfoList1({
      appKey: query.appKey,
      openStateType: 0,
    });

    // 请求组件订阅数据
    // queryComponentCount({
    //   appKey: query.appKey
    // }).then((res) => {
    //   setcomponentCount(res.data.result);
    // });
    componentData({
      appKey: query.appKey,
      subState: 1,
      pageSize: 20
    });
    componentData({
      appKey: query.appKey,
      subState: 0,
      pageSize: 20
    });
  };

  const componentData = async (data) => {
    const res = await queryComponentList(data);
    var componentData = [] 
    data.subState === 1 ? setcomponentRes1(res.data.result) : setcomponentRes0(res.data.result)
    if (res.data.success && res.data.result.items) {
      componentData = await Promise.all(res.data.result.items.map(async(item, index) => {
        // 加驳回原因
        if(item.auditStatus === 0) {
          const params = {
            appKey: query.appKey,
            componentId: item.componentId, 
            auditStatus: 0
          }
          const reason = await queryRejectReason(params)
          if (reason.data.success && reason.data.result) {
            item.reason = reason.data.result
            // console.log('item', item)
          }
        }
        return {
          type: item.componentGroupName,
          name: item.componentName,
          desc: item.componentDesc,
          key: item.componentId,
          auditStatus: item.auditStatus,
          // auditStatus: 审核状态0：驳回，1：通过，2：审核中 3.未订阅
          status:
            data.subState === 1 ?
              <span className="item-status in">
                <i></i>已订阅
              </span> :
            (
              <>
                { item.auditStatus === 3 &&
                  <span className="item-status un">
                    <i></i>未订阅
                  </span> 
                }
                { item.auditStatus === 2 &&
                  <span className="item-status ing">
                    <i></i>审核中
                  </span>
                }
                { item.auditStatus === 0 &&  
                  <span className="item-status error">
                    <Popover placement="bottomLeft" title="审核未通过" content={<div>
                        <p>{item.reason}</p>
                      </div>}>
                      <i></i>
                    </Popover>驳回
                  </span>
                }
              </>
            ),
          oper:
            data.subState === 1 ? (
              <a
                className="subscribe_table_link"
                onClick={(e) => {
                  e.preventDefault();
                  conmonentLink(item.componentArticle);
                }}
              >
                {"对接方案"}
              </a>
            ) : (
              <>
                { item.auditStatus && item.auditStatus === 3 ?
                  <a
                    className="subscribe_table_link"
                    onClick={(e) => {
                      e.preventDefault();
                      conmonentLink(item.componentArticle);
                    }}
                  >
                    {"组件详情"}
                  </a> :
                  <a
                    className="subscribe_table_link"
                    onClick={(e) => {
                     e.preventDefault();
                     // 撤销订阅
                     cancelDialog(item.componentId);
                   }}
                  >
                    {"撤销订阅"}
                  </a>
                }
              </>
            )
        };
      }));
    }
    data.subState === 1 ? setcomponentData1(componentData) : setcomponentData0(componentData)
    // console.log('setcomponentData1', componentData1)
    // console.log('setcomponentData0', componentData0)
  }

  const queryClientLimitInfoList = async (data) => {
    const res = await appPackqueryAuthPackList(data);
    var tableData1 = [];
    if (res.data.success && res.data.result) {
      tableData1 = res.data.result.map((item, index) => {
        return {
          name: item.authPackName,
          type: item.authPackDesc,
          group: item.auditTypeDesc,
          key: item.authPackId,
          status:
            item.openStateType === 0 ? (
              <span className="item-status un">
                <i></i>未开通
              </span>
            ) : item.openStateType === 1 ? (
              <span className="item-status in">
                <i></i>已开通
              </span>
            ) : (
              <span className="item-status in">
                <i></i>审核中
              </span>
            ),
          oper:
            item.openStateType && item.openStateType === 1 ? (
              <>
                <a
                  className="subscribe_table_link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDetail(item.authPackId);
                  }}
                >
                  {"权限详情"}
                </a>
                <a
                  className="subscribe_table_link fenge"
                  onClick={(e) => {
                    e.preventDefault();
                    handleHelp(
                      item.flag,
                      item.authPackId,
                      item.authPackName,
                      item.articleId
                    );
                  }}
                >
                  {"对接帮助"}
                </a>
            
              </>
            ) : (
              <a
                className="subscribe_table_link"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                {"开通权限"}
              </a>
            ),
        };
      });
    }
    settableData1(tableData1);
  };
  const queryClientLimitInfoList1 = async (data) => {
    const res = await appPackqueryAuthPackList(data);
    var tableData2 = [];
    if (res.data.success && res.data.result) {
      tableData2 = res.data.result.map((item, index) => {
        return {
          name: item.authPackName,
          type: item.authPackDesc,
          group: item.auditTypeDesc,
          key: item.authPackId,
          status:
            item.openStateType === 0 ? (
              <span className="item-status un">
                <i></i>未开通
              </span>
            ) : item.openStateType === 1 ? (
              <span className="item-status in">
                <i></i>已开通
              </span>
            ) : (
              <span className="item-status un">
                <i></i>审核中
              </span>
            ),
          oper:
            item.openStateType === 0 ? (
              <a
                className="subscribe_table_link"
                onClick={(e) => {
                  e.preventDefault();
                  confirmDialog1(item.authPackId, item.authPackName);
                }}
              >
                {"开通权限"}
              </a>
            ) : item.openStateType === 1 ? (
              <>
                <a
                  className="subscribe_table_link"
                  onClick={(e) => {
                    e.preventDefault();
                    handleDetail(item.authPackId);
                  }}
                >
                  {"权限详情"}
                </a>
                <a
                  className="subscribe_table_link fenge"
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleHelp(
                      item.flag,
                      item.authPackId,
                      item.authPackName,
                      item.articleId
                    );
                  }}
                >
                  {"对接帮助"}
                </a>
              </>
            ) : (
              <span className="gray">- </span>
            ),
        };
      });
    }
    settableData2(tableData2);
  }
  // 新增/修改/查看配置项弹窗
  const openConfig = async (componentId, type, auditStatus) => {
    // console.log("type", type)
    setModalState(type)
    if(type != 'add') {
      const configRes = await querySubmitComponentConfig({
      // const configRes = await queryComponentConfig({
        appKey: query.appKey,
        componentId: componentId,
        auditStatus: auditStatus // 仅支持状态：审核中2和已订阅1 
      })
      handelConfigData(componentId, configRes, type)
    } else {
      // console.log("componentId", componentId)
      const configRes = await queryComponentConfig({
        appKey: query.appKey,
        componentId: componentId
      })
      // console.log('configRes', configRes)
      handelConfigData(componentId, configRes, type)
    }
  }
  const handelConfigData = (componentId, configRes, type) => {
    setIsCompoentId(componentId)
    // console.log('配置项', configRes)
    if(configRes?.data?.result && configRes?.data?.result?.config && configRes?.data?.result?.config.length > 0) {
      // console.log('有数据', configRes?.data?.result.config)
      if(typeof configRes?.data?.result.config === 'string') {
        configRes.data.result.config = JSON.parse(configRes.data.result.config)
      }
      // console.log('配置项 config', configRes.data.result.config)
      if (configRes?.data?.success && configRes?.data?.result?.config?.length > 0) {
        let config = configRes.data.result.config
        setConfigDesc(configRes?.data?.result?.configDesc)
        setConfigData([...config])
        // console.log('config', config)
        // console.log('configData', configData)
        configRes.data.result.config.forEach((item, index) => {
          let colorData = {};
          colorData = {
            value: item.name || '',
            color: item.value || ''
          }
          // if(index === 1) {
          //   setConfigColor([]);
          // }
          configColor.push(colorData)
          setConfigColor(configColor)
        })
        setIsConfogVisible(true)
        if(type == 'check') {
          setIsDisabled(true)
        } else {
          setIsDisabled(false)
        }
      }
    } else {
      // 如果配置项为空
      if(configRes?.data?.success) {
        if(type !== 'add' ) {
          Message.showMsg({
            showIcon: true,
            type:  "info" ,
            description: "无相关配置项",
            autohide: true,
            closable: false,
            duration: 5000,
            onClose: () => {
            // queryClientLimitInfoList1({appKey: query.appKey,openStateType:0})
            },
          });
        }
        else {
          openComponent(componentId)
        }
      } 
    }
  }
  const onSumbit = (values) => {
    // console.log('Success:', JSON.stringify(values));
    // console.log('configColor:', configColor);
    setConfigColor([]); // 清空颜色数据
    setIsConfogVisible(false)
    configData.forEach((item, index)=> {
      let name = item.name
      item.value = values[name]
      // console.log('item', item)
      if(item.type === "input-color") {
        item.value = configColor[index].color
      }
      if(item.type === "input-file" && values[name]) {
        let file = []
        item.data = []
        if(values?.[name]?.[0]?.response?.result?.[0]){
          file = values?.[name]?.[0]?.response?.result?.[0]
          // console.log('file', file)
          item.data.push(file)
          item.value = file.url
        }
      }
    })
    openComponent(isCompoentId, configData)
  };
  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };
  // 订阅组件
  const openComponent = async(componentId, configData) =>{
    // console.log('componentId', componentId)
    const res = await subComponent({
      appKey: query.appKey,
      // clientId: overviewStore.clientId,
      componentId: componentId,
      componentConfig: configData
    });
    const flag =res.data.success;
    // console.log('res', res)
    if(flag){
      Message.showMsg({
        showIcon: true,
        type:  "success" ,
        description: "已成功提交订阅，请耐心等待审核",
        autohide: true,
        closable: false,
        duration: 5000,
        onClose: () => {
         // queryClientLimitInfoList1({appKey: query.appKey,openStateType:0})
        },
      });
      componentData({
        appKey: query.appKey,
        subState: 0,
      });
      componentData({
        appKey: query.appKey,
        subState: 1,
      });
    }
  }
  // 取消订阅组件
  const handelCancelComponent = async(componentId) =>{
    const res = await cancelComponent({
      appKey: query.appKey,
      componentId: componentId
    });
    // console.log('res', res)
    const flag =res.data.success;
    if(flag){
      Message.showMsg({
        showIcon: true,
        type:  "success" ,
        description: "取消订阅成功",
        autohide: true,
        closable: false,
        duration: 5000,
        onClose: () => {
        },
      });
      componentData({
        appKey: query.appKey,
        subState: 0,
      });
      componentData({
        appKey: query.appKey,
        subState: 1,
      });
    }
  }
  // 取消订阅组件弹窗
  const cancelDialog = async(componentId) =>{
    let binContact = Dialog.confirm({
      children: <div className="cancel_pack">组件将降低开发成本提升生产效率，您确定要撤销订阅吗？</div>,
      width:"350",
      wrapStyle: {
        zIndex: 99,
      },
      type: 'warn',
      actions: [
        {
          text: "确定",
          onClick: () => {
            handelCancelComponent(componentId)
            binContact.close();
          },
          className: "sure",
          styleType: "primary",
          autoClose: false,
        },
        {
          text: "取消",
          onClick: () => binContact.close(),
          className: "cancel",
          styleType: "",
        },
      ],
      className: "cancel_dialog",
    });
  }
  // 关闭弹窗
  const onConfigCancel = () => {
    setIsConfogVisible(false);
    setConfigColor([]); // 清空颜色数据
    setConfigData([]); // 清空颜色数据
    if(modalState !== 'check' ) {
      setTimeout(()=> {
        // form.resetFields(); // 没用
        formEl.current.resetFields(); // 离开时清除表单数据
      }, 100)
    }
  }

  const confirmDialog1=(authPackId,authPackName) =>{
    let binContact = Dialog.confirm({
      title: "开通权限包",
      children: <div className="open_auth_pack">确定开通 <span className="open_auth_pack_name">{authPackName}</span> 吗？</div>,
      width:"350",
      wrapStyle: {
        zIndex: 99,
      },
      type: 'warn',
      actions: [
        {
          text: "确定",
          onClick: () => {
            openAuthPack(authPackId)
            binContact.close();
          },
          className: "sure",
          styleType: "primary",
          autoClose: false,
        },
        {
          text: "取消",
          onClick: () => binContact.close(),
          className: "cancel",
          styleType: "",
        },
      ],
      className: "bind_dialog1",
    });
  }
  const openAuthPack=async (authPackId)=>{
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });
    const res = await switchAuthPack({
      appKey: query.appKey,
      openStateType:1,
      authPackId:authPackId
    });
    const flag =res.data.success ;
    if(flag){
      Message.showMsg({
        showIcon: true,
        type:  "success" ,
        description: "成功",
        autohide: true,
        closable: false,
        onClose: () => {
         // queryClientLimitInfoList1({appKey: query.appKey,openStateType:0})
        },
      });
      queryClientLimitInfoList1({appKey: query.appKey,openStateType:0})
    }else{
      Message.showMsg({
        showIcon: true,
        type:  "warn" ,
        description: "失败",
        autohide: true,
        closable: false,
        onClose: () => {
         
        },
      });
    }
  }

 const handleHelp= (flag, authPackId, authPackName, articleId) => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  if (flag) {
    history.push(
      `/app/frame/schemelist?appKey=${query.appKey}&authId=${authPackId}&authPackName=${encodeURIComponent(
        authPackName
      )}`
    );
  } else {
    history.push(
      `/app/frame/schemedetail?appKey=${query.appKey}&authId=${authPackId}&authPackName=${encodeURIComponent(
        authPackName
      )}&articleId=${articleId}`
    );
  }
}
const handleDetail=(authPackId)=>{
  const urlQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
  const { appKey } = urlQuery;
  Dialog.confirm({
    title: "权限详情",
    children: (
      <PermissionDetail
        authPackId={authPackId}
        appKey={appKey}
      ></PermissionDetail>
    ),
    actions: [],
    wrapStyle: {
      zIndex: 99,
    },
    className: "app_detail",
  });
}
  const conmonentLink=(componentArticle)=>{
    history.push(`/doc/guide/?id=${componentArticle}`);
  }

  const handleItemClick = (args) => {
    setDefaultCurrent(1);
    setGroupName(args[0].children);
    let data = {
      appKey: query.appKey,
      pageIndex: 1,
    };
    if (status != -1) {
      data["openState"] = status;
    }
    if (args[0].children != "请选择") {
      data["groupName"] = args[0].children;
      setGroupStyle(true);
    } else {
      setGroupStyle(false);
    }
    subscriptionStore.queryClientMsgInfoList(data);
  };
  const handleTabClick = (index) => {
    settabActive(index);
    setDefaultCurrent(1);
    index === 0
      ? settabtabMsg("暂无已开通权限包")
      : settabtabMsg("暂无未开通权限包");
  };
  const handleTabClick1 = (index) => {
    settabActive(index);
    setPageCurrent(1);
    index === 0
      ? settabtabMsg("暂无已订阅组件")
      : settabtabMsg("暂无未订阅组件");
  };
  const handleStateClick = (args) => {
    setDefaultCurrent(1);
    setStatus(args[0].value);
    let data = {
      appKey: query.appKey,
      pageIndex: 1,
    };
    if (args[0].value != -1) {
      data["openState"] = args[0].value;
      setStateStyle(true);
    } else {
      setStateStyle(false);
    }
    if (groupName !== "请选择") {
      data["groupName"] = groupName;
    }
    subscriptionStore.queryClientMsgInfoList(data);
  };

  const handlePage = (index, size) => {
    setDefaultCurrent(index === 0 ? 1 : index);
    let data = {
      appKey: query.appKey,
      pageIndex: index,
    };
    if (status != -1) {
      data["openState"] = status;
    }
    if (groupName !== "请选择") {
      data["groupName"] = groupName;
    }
    subscriptionStore.queryClientMsgInfoList(data);
  };

  const componentPage = (index, size, subState) => {
    setPageCurrent(index === 0 ? 1 : index);
    componentData({
      appKey: query.appKey,
      subState: subState,
      pageSize: size,
      pageIndex: index
    });
  };

  const normFile = (e) => {
    // console.log('Upload event:', e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };

  return (
    <div className="subscribe_content">
      {empty != null ? (
        empty ? (
          <div className="no_subscribe">
            <NoPermission content="应用未绑定合同，无法进行订阅管理" />
          </div>
        ) : (
          <>
            <Tabs
              className="tabs-wrapper"
              type="line"
              onChange={(i) => {
                handleChange(i);
              }}
            >
              <Tabs.Panel label="消息订阅">
                <div className="search-wrapper">
                  <div className="search-item">
                    <label>消息分组</label>
                    <Dropdown
                      className={`subscribe_dropdown ${
                        groupStyle ? "selected" : ""
                      }`}
                      trigger="click"
                      updateButtonText={true}
                      buttonText="请选择"
                      hideOnClick={true}
                      onItemSelect={(...args) => {
                        handleItemClick(args);
                      }}
                    >
                      <Dropdown.Item value="请选择">请选择</Dropdown.Item>
                      {subscriptionStore.list.groupNameList &&
                        subscriptionStore.list.groupNameList.map(
                          (item, index) => (
                            <Dropdown.Item value={index} key={index}>
                              {item}
                            </Dropdown.Item>
                          )
                        )}
                    </Dropdown>
                  </div>
                  <div className="search-item">
                    <label>订阅状态</label>
                    <Dropdown
                      className={`subscribe_dropdown ${
                        stateStyle ? "selected" : ""
                      }`}
                      trigger="click"
                      updateButtonText={true}
                      buttonText="请选择"
                      hideOnClick={true}
                      onItemSelect={(...args) => {
                        handleStateClick(args);
                      }}
                    >
                      <Dropdown.Item value="-1">请选择</Dropdown.Item>
                      <Dropdown.Item value="1">已订阅</Dropdown.Item>
                      <Dropdown.Item value="0">未订阅</Dropdown.Item>
                    </Dropdown>
                  </div>
                </div>
                <div className="subscribe-table">
                  <Table
                    columns={tableColumn}
                    dataSource={subscriptionStore.tableData}
                    emptyText={"已选条件下暂无数据，请更换筛选条件"}
                    pagination={false}
                  />
                </div>
                <div className="subscribe_page">
                  <Pagination
                    className="per_page"
                    total={subscriptionStore.list.pageItemTotal}
                    pageSize={20}
                    viewSize={5}
                    hasChangeSize={false}
                    defaultCurrent={defaultCurrent}
                    hasJump={false}
                    hasTotal={true}
                    onChange={(index, size) => handlePage(index, size)}
                  />
                </div>
              </Tabs.Panel>
              <Tabs.Panel label="权限包订阅">
                <div className="search-wrapper">
                  <ul className="limit-list">
                    <li
                      className={tabActive === 0 ? "active" : ""}
                      onClick={() => {
                        handleTabClick(0);
                      }}
                    >
                      已开通权限（{tableData1.length}）
                    </li>
                    <li
                      className={tabActive === 1 ? "active" : ""}
                      onClick={() => {
                        handleTabClick(1);
                      }}
                    >
                      未开通权限（{tableData2.length}）
                    </li>
                  </ul>
                  {tabActive === 0 ? (
                    <div className="subscribe-table">
                      <Table
                        columns={tableColumn1}
                        dataSource={tableData1}
                        emptyText={tabMsg}
                        pagination={false}
                      />
                    </div>
                  ) : (
                    <div className="subscribe-table">
                      <Table
                        columns={tableColumn1}
                        dataSource={tableData2}
                        emptyText={tabMsg}
                        pagination={false}
                      />
                    </div>
                  )}

                  <div className="subscribe_page">
                    {/* <Pagination
                    className="per_page"
                    total={subscriptionStore.list1.pageItemTotal}
                    pageSize={20}
                    viewSize={5}
                    hasChangeSize={false}
                    defaultCurrent={defaultCurrent}
                    hasJump={false}
                    hasTotal={true}
                    // onChange={(index, size) => handlePage1(index, size)}
                  /> */}
                  </div>
                </div>
              </Tabs.Panel>
              <Tabs.Panel label="组件订阅">
                <div className="search-wrapper">
                  <ul className="limit-list">
                    <li
                      className={tabActive === 0 ? "active" : ""}
                      onClick={() => {
                        handleTabClick1(0);
                      }}
                    >
                      已订阅组件（{componentRes1.pageItemTotal}）
                    </li>
                    <li
                      className={tabActive === 1 ? "active" : ""}
                      onClick={() => {
                        handleTabClick1(1);
                      }}
                    >
                      未订阅组件（{componentRes0.pageItemTotal}）
                    </li>
                  </ul>
                  {tabActive === 0 ? (
                    <div className="subscribe-table">
                      {/* eslint-disable */}
                      <Table
                        columns={[
                          {
                            title: "组件分类",
                            dataIndex: "type",
                            key: "1",
                            width: 150,
                          },
                          {
                            title: "组件名称",
                            dataIndex: "name",
                            key: "2",
                            width: 250,
                          },
                          {
                            title: "组件描述",
                            dataIndex: "desc",
                            key: "3",
                            width: 300,
                          },
                          {
                            title: "状态",
                            dataIndex: "status",
                            key: "4",
                            width: 150,
                          },
                          {
                            title: "功能",
                            dataIndex: "action",
                            key: "5",
                            width: 150,
                            render: (text, record, index)=>{
                              return (
                                <a
                                  className="subscribe_table_link"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    // 修改配置项... 
                                    openConfig(record.key, 'edit', record.auditStatus);
                                  }}
                                >
                                  {"修改配置项"}
                                </a> 
                              )
                            }
                          },
                          {
                            title: "操作",
                            dataIndex: "oper",
                            key: "6",
                            width: 150,
                          },
                        ]}
                        dataSource={componentData1}
                        emptyText={tabMsg}
                        pagination={false}
                      />
                      <div className="subscribe_page mt24">
                        <Pagination
                          className="per_page"
                          total={componentRes1.pageItemTotal}
                          pageSize={20}
                          viewSize={5}
                          hasChangeSize={false}
                          defaultCurrent={pageCurrent}
                          hasJump={false}
                          hasTotal={true}
                          onChange={(index, size) => componentPage(index, size, '1')}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="subscribe-table">
                      {/* eslint-disable */}
                      <Table
                        columns={[
                          {
                            title: "组件分类",
                            dataIndex: "type",
                            key: "1",
                            width: 150,
                          },
                          {
                            title: "组件名称",
                            dataIndex: "name",
                            key: "2",
                            width: 250,
                          },
                          {
                            title: "组件描述",
                            dataIndex: "desc",
                            key: "3",
                            width: 300,
                          },
                          {
                            title: "状态",
                            dataIndex: "status",
                            key: "4",
                            width: 150,
                          },
                          {
                            title: "功能",
                            dataIndex: "action",
                            key: "5",
                            width: 150,
                            render: (text, record, index)=>{
                              return (
                                <>
                                  {/* 审核状态auditStatus: 0：驳回，1：通过，2：审核中 3.未订阅 */}
                                  { record.auditStatus && record.auditStatus === 2 ?
                                    <a
                                      className="subscribe_table_link"
                                      onClick={(e) => {
                                        // console.log('未订阅record', record)
                                        e.preventDefault();
                                        // 查看配置项
                                        openConfig(record.key, 'check', record.auditStatus);
                                      }}
                                    >
                                      {"查看配置项"}
                                    </a> :
                                    
                                    <a
                                      className="subscribe_table_link"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        // console.log('未订阅record', record)
                                        openConfig(record.key, 'add');
                                      }}
                                    >
                                      {"订阅"}
                                    </a>
                                  }
                                </>
                              )
                            }
                          },
                          {
                            title: "操作",
                            dataIndex: "oper",
                            key: "6",
                            width: 150,
                          },
                        ]}
                        dataSource={componentData0}
                        emptyText={tabMsg}
                        pagination={false}
                      />
                      <div className="subscribe_page mt24">
                        <Pagination
                          className="per_page"
                          total={componentRes0.pageItemTotal}
                          pageSize={20}
                          viewSize={5}
                          hasChangeSize={false}
                          defaultCurrent={pageCurrent}
                          hasJump={false}
                          hasTotal={true}
                          onChange={(index, size) => componentPage(index, size, '0')}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </Tabs.Panel>
            </Tabs>
            <Modal 
              className="config-modal" 
              width={726}
              centered
              title={<div className="title">请完善配置
                <a href={`//vop.jd.com/doc/guide?id=${configDesc}`} target="_blank">查看配置项含义</a></div>
              }
              visible={isConfogVisible}
              footer={null}
              onCancel={onConfigCancel}
            >
              { modalState && modalState === 'edit' && <div className="edit-tips">
                【修改后配置项在审核通过前，原配置项依然生效。】
              </div>}
              <Form
                ref={formEl}
                name="config"
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 20 }}
                colon={false}
                onFinish={onSumbit}
                onFinishFailed={onFinishFailed}
              >
                {/* {console.log('dom configData', configData)} */}
                { configData?.map((item, index) => {
                  return (
                    <div key={index} className={item.mode}>
                      {/* 输入框 */}
                      {item.type && item.type === "input-text" && 
                        <Form.Item
                          label={item.label + '：'}
                          name={item.name}
                          initialValue={item.value}
                          rules={[{ required: item.required, message: '请填写必填项!' }]}
                        >
                          <Input 
                            placeholder={item.placeholder} 
                            disabled={isDisabled} 
                          />
                        </Form.Item>
                      }
                      {/* 开关 */}
                      { item.type && item.type === "switch" && 
                        <Form.Item
                          label={item.label + '：'}
                          name={item.name}
                          initialValue={item.value}
                          rules={[{ required: item.required, message: '请填写必填项!' }]}
                          valuePropName="checked"
                        >
                          <Switch 
                            disabled={isDisabled}
                          />
                        </Form.Item>
                      }
                      {/* 单选框 */}
                      {item.type && item.type === "radios" && 
                        <Form.Item
                          label={item.label + '：'}
                          name={item.name}
                          initialValue={item.value}
                          rules={[{ required: item.required, message: '请填写必填项!' }]}
                        >
                          <Radio.Group 
                            value={item.value}
                          >
                            {
                              item.options && item.options.map((radioItem, radinIndex) => (
                                <Radio 
                                  key={radinIndex}
                                  value={radioItem.value}
                                  disabled={isDisabled}
                                >
                                  {radioItem.label}
                                </Radio>
                              )
                              )}
                          </Radio.Group>
                        </Form.Item>
                      }
                      {/* 多选框 */}
                      {item.type && item.type === "checkboxes" && 
                        <Form.Item
                          label={item.label + '：'}
                          name={item.name}
                          initialValue={item.value}
                          rules={[{ required: item.required, message: '请填写必填项!' }]}
                        >
                          <Checkbox.Group
                            options={item.options} 
                            // defaultValue={item.value}
                            disabled={isDisabled}
                          >
                          </Checkbox.Group>
                        </Form.Item>
                      }
                      {/* 颜色选择器 */}
                      {item.type && item.type === "input-color" && configColor && configColor[index] &&
                        <Form.Item
                          label={item.label + '：'}
                          name={item.name}
                          initialValue={configColor[index].color}
                          rules={[{ required: item.required, message: '请填写必填项!' }]}
                        >
                          <Popover 
                            overlayClassName={`config-popover ${isDisabled ? 'disabled' : ''}`}
                            content={
                              <SketchPicker
                                color={configColor[index].color}
                                // onChange={handleChangeComplete}
                                onChange={(color)=>{
                                  configColor[index].color = color.hex
                                  setConfigColor([...configColor]);
                                  // console.log('configColor', configColor)
                                  // console.log('item.color', configColor[index].color)
                                }}
                              />
                            } 
                            trigger="click"
                            getPopupContainer={
                              () => document.body	
                            }
                            // visible={isColor}
                          >
                            <div 
                              className={`colorPicker-box ${isDisabled ? 'disabled' : ''}`}
                            >
                              <div className="colorPicker-value">{configColor[index].color}</div>
                              <div className="colorPicker-show" style={{backgroundColor: configColor[index].color}}></div>
                            </div>
                          </Popover>
                        </Form.Item>
                      }
                      {/* 上传 */}
                      {/* {console.log('dom item.data', item.data)} */}
                      {item.type && item.type === "input-file" && 
                      <div className="img-wrapper-box">
                           <Form.Item
                          label={item.label + '：'}
                          name={item.name}
                          className={`flie-box ${isDisabled ? 'disabled' : ''}`}
                          valuePropName="fileList"
                          getValueFromEvent={normFile}
                          rules={[{ required: item.required, message: '请填写必填项!' }]}
                          // rules={[{ required: true, message: '请填写必填项!' }]}
                          initialValue={item?.data.length>0?[
                                {
                                    "name": item?.data.length>0 &&item?.data?.slice(-1)[0]?.name?item?.data?.slice(-1)[0]?.name:"",
                                    "type": "image/png",
                                    "status": "done",
                                    "response": {
                                        "result": [
                                            {
                                                "name": item?.data.length>0 &&item?.data?.slice(-1)[0]?.name ? item?.data?.slice(-1)[0]?.name:"",
                                                "url": item?.data.length>0 &&item?.data?.slice(-1)[0]?.url ? item?.data?.slice(-1)[0]?.url:""
                                            }
                                        ],
                                        "resultCode": "0000",
                                        "resultMessage": "success",
                                        "success": true
                                    },
                                    "xhr": {

                                    }
                                }
                        ]:[]}
                        >
                          <Upload
                            action={queryComponentUpload}
                            maxCount={1}
                            name={"file"}
                            defaultFileList={item.data}
                            beforeUpload={(file, fileList) => {
                              // console.log('beforeUpload', file, fileList);
                              const isLt10M = file.size / 1024 / 1024 < 10;
                              if (!isLt10M) {
                                message.error("文件大小需小于10MB!");
                                return false;
                              }
                              return isLt10M;
                            }}
                           onChange={(options) => {
                              const { file, fileList } = options;
                              let status = file.status;
                              if (status === "done") {
                                const newUrlObj = {...isShowImgUrlLink};
                                newUrlObj[item.name] = false;
                                setIsShowImgUrlLink(newUrlObj)
                                const newObj = {...linkUrlObj}
                                newObj[item.name] = {
                                        name:file.response?.result[0]?.name,
                                        url:file.response?.result[0]?.url,
                                }
                                setLinkUrlObj(newObj)
                              }
                            }}
                            onRemove={()=>{
                               const newUrlObj = {...isShowImgUrlLink};
                                newUrlObj[item.name] = true;
                                setIsShowImgUrlLink(newUrlObj)
                            }}
                          >
                            <Button icon={<UploadOutlined />} disabled={isDisabled}>
                              {item.btnLabel}
                            </Button>
                            <span className="desc">
                              【注】最多上传一个文件且文件大小不超过10MB
                            </span>
                          </Upload>
                        </Form.Item>
                        {(!isShowImgUrlLink[item.name] &&( linkUrlObj[item.name]?.url ||item.data?.slice(-1)[0]?.url?.length>0)) && <div className="link-box"><a href={linkUrlObj[item.name]?.url ||item.data?.slice(-1)[0]?.url} target="_blank">图片链接</a></div>}
                      </div>
                   
                      }
                    </div>
                  )
                })}

                {!isDisabled && <Form.Item
                  className="horizontal submit-box"
                  wrapperCol={{ span: 24 }}
                >
                  <div>
                    <Button htmlType="submit" type="primary">确定</Button>
                    <Button onClick={onConfigCancel}>取消</Button>
                  </div>
                </Form.Item>}
                {isDisabled && <Form.Item
                  className="horizontal submit-box"
                  wrapperCol={{ span: 24 }}
                >
                  <Button onClick={onConfigCancel}>关闭</Button>
                </Form.Item>}
              </Form>
            </Modal>
          </>
        )
      ) : (
        ""
      )}
    </div>
  );
});

export default SubscribeContent;
